__turbopack_context__.v({
  "addNewAddressButton": "-XBkwG_addNewAddressButton",
  "noItemsMessage": "-XBkwG_noItemsMessage",
  "title": "-XBkwG_title",
  "wrapper": "-XBkwG_wrapper",
});
